module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/5-a4bfc65bb37d3e039ca5cd82ca6e3853.jpg";